export default __webpack_public_path__ + "img/component-profile-card.15d5eb5a.png";